import { updateLinksAttributes, missingWidget } from '../utils.js';

export default function seoWidget() {
  const widgetName = 'seoWidget';
  const widgetOpts = typeof seoWidgetOpts === 'undefined' ? null : seoWidgetOpts;
  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }
  const $widgetHTML = $(`#${widgetName}`);

  function createCustomSeo(widgetData) {
    const $seo = $widgetHTML.find('.card-widget-item');
    const { Title, Description, URL } = widgetData[0];

    $seo.replaceWith(`
      <div class="seo-inner">
        <h1 class="seo-title">${Title}</h1>
        <div class="seo-description"><p>${Description}</p></div>
        ${URL == null ? '' : `<a href="${URL}" class="button" ${updateLinksAttributes(URL, Title)}>Learn More</a>`}
      </div>
    `);

    if ($widgetHTML.parent('.seo-container').length === 0) {
      $widgetHTML.wrap('<div class="seo-container"></div>');
      $widgetHTML.after('<div class="seo-map" aria-hidden="true"></div>');
    }
  }

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    moreButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo(data.items);
      } else {
        $widgetHTML.remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [],
    maxItemsVisible: 1,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
